import { Keyword, LengthPercentage } from "@siteimprove/alfa-css";
import { Parser } from "@siteimprove/alfa-parser";
import { Selective } from "@siteimprove/alfa-selective";
import { Longhand } from "../longhand.js";
import { Resolver } from "../resolver.js";
const { either } = Parser;
/**
 * @internal
 */
export const parse = either(Keyword.parse("auto"), LengthPercentage.parse);
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/top}
 * @internal
 */
export default Longhand.of(Keyword.of("auto"), parse, (top, style) => top.map((top) => Selective.of(top)
    .if(LengthPercentage.isLengthPercentage, LengthPercentage.partiallyResolve(Resolver.length(style)))
    .get()));
//# sourceMappingURL=top.js.map